import {
    LISTE_MYAPPSETTINGS_ONE_SUCCESS
} from "../actions/types";

const initialState = {
    myappsetting: null,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case LISTE_MYAPPSETTINGS_ONE_SUCCESS:
            return {
                ...state,
                myappsetting: payload.myappsetting,
            };

        default:
            return state;
    }
}
